"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CertificateReturn = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

var _SvgIcon = require("../SvgIcon");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CertificateReturn = function CertificateReturn(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon.SvgIcon, (0, _extends2.default)({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M3.94 4.35a5.444 5.444 0 013.874-1.6c2.976 0 5.39 2.35 5.39 5.25s-2.414 5.25-5.39 5.25c-2.088 0-3.9-1.156-4.795-2.85a.91.91 0 00-1.21-.378.864.864 0 00-.387 1.178C2.613 13.456 5.028 15 7.814 15 11.783 15 15 11.866 15 8s-3.217-7-7.186-7a7.262 7.262 0 00-5.017 1.99v-.24a.887.887 0 00-.899-.875A.887.887 0 001 2.75v2.475c0 .483.402.875.898.875h2.54a.887.887 0 00.9-.875.887.887 0 00-.9-.875H3.94z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.578 6a.5.5 0 01.5-.5H8.55a1.75 1.75 0 010 3.5h-.972v.667h1.055a.5.5 0 010 1H7.578V11a.5.5 0 01-1 0v-.333H6.3a.5.5 0 010-1h.278V9H6.3a.5.5 0 010-1h.278V6zm1 2h.972a.75.75 0 000-1.5h-.972V8z",
    fill: "currentColor"
  }));
};

exports.CertificateReturn = CertificateReturn;
var _default = CertificateReturn;
exports.default = _default;